<template>
    <div>
        <b-form enctype="multipart/form-data">
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Data"
                    label-for="paymentDate"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input v-model="accountDueDate" type="date" id="paymentDate" :class="accountDueDateField"></b-form-input>              
                    </b-form-group>          
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Valor"
                    label-for="paymentValue"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-input v-model="totalValue" id="paymentValue" type="number" :class="totalValueField"></b-form-input>
                    </b-form-group>          
                </b-col>
            </b-row>
            
            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Comprovante"
                    label-for="voucher"
                    :horizontal="false">
                        <b-form-textarea
                            id="voucher"
                            v-model="paymentVoucher"
                            placeholder=""
                            rows="5"
                        ></b-form-textarea>
                    </b-form-group>          
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Anexo"
                    label-for="attachment"
                    :label-cols="3"
                    :horizontal="false">
                        <file-drop-area-component v-model="fileToSend"></file-drop-area-component>
                    </b-form-group>
                </b-col>
            </b-row>

            <hr>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Conta"
                    label-for="paymentAccount"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-select id="paymentAccount"
                            v-model="paymentAccountId"
                            :plain="true"
                            :options="paymentAccountDDL"
                            value="Conta">
                        </b-form-select>
                    </b-form-group>          
                </b-col>
            </b-row>

            <b-row>
                <b-col md="12">
                    <b-form-group
                    description=""
                    label="Forma de Pagamento"
                    label-for="mop"
                    :label-cols="3"
                    :horizontal="true">
                        <b-form-select id="mop"
                            v-model="mopId"
                            :plain="true"
                            :options="mopDDL"
                            value="Forma de Pagamento">
                        </b-form-select>
                    </b-form-group>          
                </b-col>
            </b-row>
        </b-form>

        <b-input-group class="mb-4">
            <div class="text-danger" v-if="this.errorMessage && this.errorMessage != ''"><i class="fa fa-exclamation-triangle fa-lg mt-4"></i> {{ this.errorMessage }}</div>
        </b-input-group>
    
        <div slot="footer" class="text-right">
            <b-button variant="github" class="mr-1 btn-brand" @click="addPayment()"><i class="fa fa-check"></i><span>Adicionar Pagamento</span></b-button>
        </div>

    </div>    
</template>


<script>
import Vue from 'vue'
import axios from "axios";

//import ProductSelectComponent from '../stock/ProductSelectComponent'

/* Toast */
import VueNotifications from 'vue-notifications'
import miniToastr from 'mini-toastr'// https://github.com/se-panfilov/mini-toastr
//import { table } from 'console'

import PaymentGridComponent from './PaymentGridComponent'
import FileDropAreaComponent from '../../components/FileDropAreaComponent.vue'

const toastTypes = {
success: 'success',
error: 'error',
info: 'info',
warn: 'warn'
}

miniToastr.init({types: toastTypes})

function toast ({title, message, type, timeout, cb}) {
return miniToastr[type](message, title, timeout, cb)
}

const options = {
success: toast,
error: toast,
info: toast,
warn: toast
}
VueNotifications.setPluginOptions(options)

Vue.use(VueNotifications, options)
/* Toast - End */

export default {
    name: 'paymentComponent',
    props: {
        item: Object,
        accountType: String,
        companyId: String
    },
    watch: {
        itemValue: {
            immediate: true,
            handler(newValue) {
                this.accountDueDate = this.item.dueDate
                this.totalValue = this.item.totalValue
                if(this.item.fees) this.totalValue += this.item.fees
                if(this.item.discount) this.totalValue -= this.item.discount
                if(this.item.paymentValue) this.totalValue -= this.item.paymentValue
            }
        }
    },
    components: {
//        ProductSelectComponent
        FileDropAreaComponent
    },
    data: () => {
        return {
            totalValueField: '',
            accountDueDateField: '',

            mopId: 0,
            accountDueDate: '',
            totalValue: 0,
            fileToSend: null,

            paymentVoucher: '',
            paymentAccountId: 0,
            currentItem: { st: 'A'},
            errorMessage: "",
            notes: "",

            paymentAccountDDL: [],
            mopDDL: []
        }
    },
    computed: {
       currentAccount() {
            this.accountDueDate = this.item.dueDate
            return this.item
       }
    },
    methods: {

        async saveItem() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            let formData = new FormData();

            formData.append('accountId', s.item.id)
            formData.append('totalValue', s.totalValue)
            if(s.mopId && s.mopId > 0)
                formData.append('mopId', parseInt(s.mopId))
            if(s.paymentAccountId && s.paymentAccountId > 0)
                formData.append("paymentAccountId", parseInt(s.paymentAccountId))
            formData.append("paymentDate", new Date(s.accountDueDate + "T12:00:00.000Z"))
            formData.append("paymentVoucher", s.paymentVoucher )
            formData.append('file', this.fileToSend);
            formData.append('notes', s.notes)
            formData.append('uid', currentUser.id);
            formData.append('sid', currentUser.sid);
            
            var url = this.$store.state.ws_url + "/finance/ap/payment"
            if(s.accountType == 'R')
                url = this.$store.state.ws_url + "/finance/ar/payment"

            //console.log(url)

            await axios.post(
                url,
                formData
            ).then(function(resp) {
                //console.log("Pagamento processado")                
                s.$emit('item-selected', formData);                

            }).catch(function(error) {
                //console.log("Erro ao processar pagamento")
                console.log(error)
            })
            
        },

        addPayment() {

            let msgError = [];

            if(this.accountDueDate == null) {
                this.accountDueDateField = 'is-invalid'
                msgError.push("Data");
            }
            else {
                this.accountDueDateField = ''
            }

            if(this.totalValue == null || this.totalValue <= 0) {
                msgError.push("Valor");
                this.totalValueField = 'is-invalid'
            }
            else {
                this.totalValueField = ''
            }
            
            if(msgError.length > 0) {
                let msgErrorExt = "Verifique os campos: ";
                let msgErrorSep = "";
                msgError.forEach(function(element) { msgErrorExt += msgErrorSep + element; msgErrorSep=", "; } )

                toast ({
                    type: VueNotifications.types.error,
                    title: 'Pagamento',
                    message: msgErrorExt,
                    timeout: 5000
                })
            }
            else {
                this.saveItem();
            }

        },


        async getPaymentAccount() {
            var s = this;
            var currentUser = this.$store.state.currentUser;

            await axios.get(
                this.$store.state.ws_url + "/payment/account/ddl?companyId=" + s.companyId + "&uid=" + currentUser.id + "&sid=" + currentUser.sid
                
            ).then(function(resp) {
                s.paymentAccountDDL = resp.data.obj;
            }).catch(function (error) {
                console.log(error);
            });
        },

        async getMop() {
            var s = this;
            var currentUser = this.$store.state.currentUser;
        
            await axios.get(
                this.$store.state.ws_url + "/mop/ddl?uid=" + currentUser.id + "&sid=" + currentUser.sid
                
            ).then(function(resp) {
                s.mopDDL = resp.data.obj;
            }).catch(function (error) {
                console.log(error);
            });
        },
        
        refreshData() {
            
        }
    },
    mounted: function() {
        this.getMop()
        this.getPaymentAccount()
    }

}

</script>